import ColorPicker from 'pages/Whiteboard/controlPanel/ColorPicker';

import DropDown from '../MenuItemDropdown';
import style from '../SelectedItemMenu.module.css';

interface Props {
  color: string;
  onChange: (val) => void;
}
const BorderColorPicker = (props: Props) => {
  return (
    <DropDown
      trigger={<div className={style.colorSelector} style={{ borderColor: props.color }}></div>}
      closeOnClick={true}
    >
      <ColorPicker
        theme="dark"
        value="black"
        onChange={val => {
          props.onChange({ changed: 'color', value: val });
        }}
      />
    </DropDown>
  );
};

export default BorderColorPicker;
